import React from 'react'

const ErrorPage = () => {
  return (
    <div className='generalStyle'>
    <h1 style={{color: "#660707"}}>404 Page : Page not found</h1>
    </div>
  );
};

export default ErrorPage;